import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { Container, useUi } from '@weareconceptstudio/core';

//* Styles
import ProductsSliderStyle from './style';

//* Helpers
import { config } from '@/helpers';

//* Components
import Button from '@/components/Button';
import TitleAnim from '@/modules/_animation/Title';
import StyledQuotedText from '@/components/StyledQuotedText';
import ProductItem from '@/modules/Products/components/List/Item';

gsap.registerPlugin(ScrollTrigger);

const ProductsSlider = ({ data }) => {
	const { winWidth } = useUi();

	const styleRef = useRef();
	const triggerRef = useRef();
	const buttonRef = useRef();
	const swiperRef = useRef();

	//! Animation
	useEffect(() => {
		if (styleRef.current && data) {
			if (swiperRef.current) {
				swiperRef.current?.swiper?.autoplay?.stop();
			}

			triggerRef.current = ScrollTrigger.create({
				start: 'top bottom',
				end: 'top top',
				trigger: styleRef.current,
				onEnter: () => {
					if (buttonRef.current) {
						gsap.fromTo(buttonRef.current, { scale: 0 }, { scale: 1, duration: 0.6, ease: 'power2.inOut' });

						const allSlideItem = styleRef.current?.querySelectorAll('.wrapper-item-slide');
						allSlideItem.forEach((item, ind) => {
							gsap.fromTo(item, { y: `${20 * (ind + 1)}%`, opacity: 0 }, { y: 0, delay: ind * 0.1, opacity: 1 }).then(() => {
								if (ind == 6) {
									swiperRef.current?.swiper?.autoplay?.start();
								}
							});
						});
					}
				},
				onLeaveBack: () => {
					if (buttonRef.current) {
						gsap.killTweensOf(buttonRef.current);
						gsap.set(buttonRef.current, { scale: 0 });
					}
				},
			});
		}

		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	}, [data, winWidth]);

	return (
		<ProductsSliderStyle ref={styleRef}>
			{data.length ? (
				<Container isSection>
					<div className='wrapper-title-button'>
						<TitleAnim
							animRefTrigger={styleRef}
							trigger={'bottom'}
							load={true}
						>
							<StyledQuotedText text={'our" ""products"'} />
						</TitleAnim>
						<div
							ref={buttonRef}
							className='wrapper-button-info'
						>
							<Button
								url={`${config.routes.products.path}`}
								text={'viewAll'}
								className={'show-more-btn'}
							/>
						</div>
					</div>

					{winWidth >= 768 ? (
						<Swiper
							ref={swiperRef}
							modules={[Autoplay]}
							slidesPerView={'auto'}
							autoplay={{
								delay: 3500,
								disableOnInteraction: false,
							}}
						>
							{data.map((item, index) => {
								return (
									<SwiperSlide key={index}>
										<div className='wrapper-item-slide'>
											<ProductItem
												// isHome
												// className={'no-hover'}
												{...item}
											/>
										</div>
									</SwiperSlide>
								);
							})}
						</Swiper>
					) : (
						<div className='wrapper-slide'>
							{data.map((item, index) => {
								return (
									<div
										key={index}
										className='wrapper-item-slide'
									>
										<ProductItem
											// isHome
											// className={'no-hover'}
											{...item}
										/>
									</div>
								);
							})}
						</div>
					)}
				</Container>
			) : null}
		</ProductsSliderStyle>
	);
};

export default ProductsSlider;
